module.exports = __webpack_public_path__ + "static/fonts/Montserrat700italic.215a9e63.ttf";